import Image, { type ImageProps } from 'next/image'
import * as Dialog from '@radix-ui/react-dialog'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import CloseButton from '@hashicorp/react-close-button'
import s from './style.module.css'

interface ImageLightboxProps {
	onDismiss: () => void
	image: ImageProps
}

export default function ImageLightbox({
	onDismiss,
	image,
}: ImageLightboxProps) {
	return (
		<Dialog.Root
			open={true}
			onOpenChange={(isOpen) => {
				!isOpen && onDismiss()
			}}
		>
			<Dialog.Portal>
				<Dialog.Overlay className={s.dialogOverlay}>
					<div className={s.closeIconBttnWrapper}>
						<CloseButton ariaLabel={'Close lightbox'} onClick={onDismiss} />
					</div>
				</Dialog.Overlay>
				<Dialog.Content className={s.dialogContent}>
					<VisuallyHidden asChild>Image</VisuallyHidden>
					<div className={s.image}>
						<Image
							src={image.src}
							alt={image.alt}
							width={image.width}
							height={image.height}
							priority
						/>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	)
}
